import { render, staticRenderFns } from "./PrivacyTerms.vue?vue&type=template&id=5a1e7873&scoped=true&"
import script from "./PrivacyTerms.vue?vue&type=script&lang=js&"
export * from "./PrivacyTerms.vue?vue&type=script&lang=js&"
import style0 from "./PrivacyTerms.vue?vue&type=style&index=0&id=5a1e7873&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1e7873",
  null
  
)

export default component.exports